import TagId from '~/constants/common/TagId';
import type { AppliedFilters } from '~/contracts/common';
import useGetVehicles from '~/hooks/home/services/useGetVehicles';

const priceDropFilter: Partial<AppliedFilters> = {
  tagIds: [String(TagId.PriceDrop)]
};

export default function useGetPriceDropVehicles() {
  return useGetVehicles(priceDropFilter, true, 'Price Drop Vehicles');
}
